// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.home[data-v-764d1b8c] {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\n}\n.banner[data-v-764d1b8c] {\r\n  width: 100%;\n}\n.bannerLine[data-v-764d1b8c] {\r\n  display: flex;\r\n  justify-content: space-around;\r\n\r\n  background-color: #f78129;\r\n\r\n  width: 100%;\r\n  padding: 5px;\n}\n.text[data-v-764d1b8c] {\r\n  font-size: 0.7rem;\r\n  color: #fff;\r\n  text-align: center;\n}\r\n", ""]);
// Exports
module.exports = exports;
